import { defineTable } from "convex/server";
import { v } from "convex/values";

export const waitlistStatus = v.union(
  v.literal("pending"),
  v.literal("approved"),
  v.literal("rejected"),
);

export const industryOptions = v.union(
  v.literal("retail"),
  v.literal("wholesale"),
  v.literal("manufacturing"),
  v.literal("services"),
  v.literal("food_beverage"),
  v.literal("healthcare"),
  v.literal("education"),
  v.literal("technology"),
  v.literal("construction"),
  v.literal("agriculture"),
  v.literal("other"),
);

export const companySizeOptions = v.union(
  v.literal("1-10"),
  v.literal("11-50"),
  v.literal("51-200"),
  v.literal("200+"),
);

export const validatorWaitlist = v.object({
  email: v.string(),
  name: v.string(),
  company: v.optional(v.string()),
  industry: v.optional(industryOptions),
  companySize: v.optional(companySizeOptions),
  referralCode: v.string(),
  referredBy: v.optional(v.string()),
  referralCount: v.number(),
  status: waitlistStatus,
  approvedAt: v.optional(v.number()),
  createdAt: v.number(),
});

export const waitlist = defineTable(validatorWaitlist)
  .index("by_email", ["email"])
  .index("by_referral_code", ["referralCode"])
  .index("by_status", ["status"])
  .index("by_referred_by", ["referredBy"])
  .index("by_created_at", ["createdAt"])
  .searchIndex("search_waitlist", {
    searchField: "name",
    filterFields: ["status"],
  });
